



























































































































































































































































import Vue from 'vue';
import SimpleFileUploader from '@/components/SimpleFileUploader.vue';
import {ExtensionViewModel} from "../../models/ExtensionViewModel";
import BoxContainer from "@/components/BoxContainer.vue";
import {ExtensionDocumentViewModel} from "@/models/ExtensionDocumentViewModel";
import {ReturnDataViewModel} from "@/models/ReturnDataViewModel";

export default Vue.extend({
  name: "ExtensionDocuments",
  components: {
    BoxContainer,
    SimpleFileUploader
  },
  data(): {
    dialogDeleteFile: boolean;
    isNeedSupplementalForm: boolean;
    parentId :number;
    extension: ExtensionViewModel;
    documentList: ExtensionDocumentViewModel[];
    resetUploader: boolean;
    uploadFile: boolean;
    isReadyDocuments: any;
    readyDocumentNames: any;
    readyDocumentSizes: any;
    readyDocumentIds: any;
    //totalFileSize: number;
  }{
    return {
      dialogDeleteFile: false,
      isNeedSupplementalForm: false,
      parentId: 0,
      extension: {} as ExtensionViewModel,
      documentList: [] as ExtensionDocumentViewModel[],
      resetUploader: false,
      uploadFile: false,
      isReadyDocuments: {
        isSupplementalForm: false,
        isKeyPlan: false ,
        isProfilePrint: false,
        isOptionalOne: false,
        isOptionalTwo: false,
        isOptionalThree: false
      } as any,
      readyDocumentNames: {
        supplementalForm: "",
        keyPlan: "" ,
        profilePrint: "" ,
        optionalOne: "" ,
        optionalTwo: "" ,
        optionalThree: ""
      } as any ,
      readyDocumentSizes: {
        supplementalForm: 0,
        keyPlan: 0 ,
        profilePrint: 0 ,
        optionalOne: 0 ,
        optionalTwo: 0 ,
        optionalThree: 0
      } as any ,
      readyDocumentIds: {
        supplementalForm: 0,
        keyPlan: 0 ,
        profilePrint: 0 ,
        optionalOne: 0 ,
        optionalTwo: 0 ,
        optionalThree: 0
      }
      //totalFileSize: 0
    }
  },
  computed: {
    apiURL() {
      return process.env.VUE_APP_API_URL
    },
    isReadyForSubmissionDocuments():boolean {
      let isReadyForSubmit = false;
      isReadyForSubmit = (this.isReadyDocuments.isKeyPlan && this.isReadyDocuments.isProfilePrint);
      return isReadyForSubmit;
    },
    totalFileSize(): number {
      let totalSize = this.readyDocumentSizes.supplementalForm + this.readyDocumentSizes.keyPlan + this.readyDocumentSizes.profilePrint + this.readyDocumentSizes.optionalOne + this.readyDocumentSizes.optionalTwo + this.readyDocumentSizes.optionalThree;
      return totalSize;
    }
  },
  methods: {
    async loadData() {
      let result = await this.axios.get( '/Extensions/GetOne' , {
        params: {
          id: this.parentId
        }
      });

      this.extension = result.data;
      this.isNeedSupplementalForm = this.extension.isRedirectingFlow || this.extension.isAddingFlow;

      let result2 = await this.axios.get( '/ExtensionDocuments/GetDocumentsForExtension' , { params: { extensionId: this.parentId }});

      this.documentList = result2.data;

      console.log( '*** loadData method of ExtensionDocuments.vue' );
      console.log( this.documentList);

      // Handle Setting the controls for documents already uploaded
      for ( const n of this.documentList ){
        switch ( n.documentType ) {
          case "SupplementalForm":
            this.isReadyDocuments.isSupplementalForm = true;
            this.readyDocumentNames.supplementalForm = n.fileName;
            this.readyDocumentSizes.supplementalForm = n.fileLength;
            this.readyDocumentIds.supplementalForm = n.extensionDocumentId;
            break;
          case "KeyPlan":
            this.isReadyDocuments.isKeyPlan = true;
            this.readyDocumentNames.keyPlan = n.fileName;
            this.readyDocumentSizes.keyPlan = n.fileLength;
            this.readyDocumentIds.keyPlan = n.extensionDocumentId;
            break;
          case "ProfilePrint":
            this.isReadyDocuments.isProfilePrint = true;
            this.readyDocumentNames.profilePrint = n.fileName;
            this.readyDocumentSizes.profilePrint = n.fileLength;
            this.readyDocumentIds.profilePrint = n.extensionDocumentId;
            break;
          case "OptionalOne":
            this.isReadyDocuments.isOptionalOne = true;
            this.readyDocumentNames.optionalOne = n.fileName;
            this.readyDocumentSizes.optionalOne = n.fileLength;
            this.readyDocumentIds.optionalOne = n.extensionDocumentId;
            break;
          case "OptionalTwo":
            this.isReadyDocuments.isOptionalTwo = true;
            this.readyDocumentNames.optionalTwo = n.fileName;
            this.readyDocumentSizes.optionalTwo = n.fileLength;
            this.readyDocumentIds.optionalTwo = n.extensionDocumentId;
            break;
          case "OptionalThree":
            this.isReadyDocuments.isOptionalThree = true;
            this.readyDocumentNames.optionalThree = n.fileName;
            this.readyDocumentSizes.optionalThree = n.fileLength;
            this.readyDocumentIds.optionalThree = n.extensionDocumentId;
            break;
          default:
        }
      }
      console.log( "HERE WE ARE");
      console.log(this.readyDocumentIds);
    },
    uploadSuccess(file: any, response: any ): void {

      setTimeout(() => {
        this.resetUploader = true
      }, 3000);

      this.resetUploader = false;
      this.uploadFile = false;
      const data = response.body as string;

      console.log( data);
    },
    uploadError(file: any, response: any): void {
      this.uploadFile = false
      console.log(response);
    },
    async handleDetails() {
      await this.$router.push({ name: "extensions-detail" , params: { itemId: this.parentId.toString()}});
    },
    bytesForHuman(bytes: number, decimals = 2) : string {
      let units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB']

      let i = 0

      for (i; bytes > 1024; i++) {
        bytes /= 1024;
      }

      return parseFloat(bytes.toFixed(decimals)) + ' ' + units[i]
    },
  } ,
  mounted() {
    this.parentId = parseInt(this.$route.params.id);
    this.loadData();
  },
  beforeCreate() {
    setTimeout( async () => {
      if ( this.$store.state.loggedInUser == null ) {
        //make one attempt to get the current user info
        try {
          let result = await this.axios.get('Users/GetUserFromToken');
          if ( result.status === 200 ) {
            await this.$store.dispatch('updateUser', result.data);
          }
        } catch ( err ) {
          if ( err.response.status === 400  ) {
            await this.$router.push('/Login');
          }
        }
      }
    } , 250 );
  },
})
